import {
    Modal,
    Form,
} from "react-bootstrap";

export default function ErrorModal(props) {
    return (

        <Modal show={props&&props.showModal}
         onHide={props.closeModal} 
        className="main_modl">
            <Modal.Header closeButton>
                <Modal.Title style={{color:'red'}} className="text_theme">
                 {props.modalData.tittle}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="prfl_flds">
                    <Form>
                        <Form.Group
                            className="mb-3"
                            controlId="exampleForm.ControlTextarea1"
                        >
                            <Form.Label>{props.modalData.label}</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={4}
                                placeholder="Write your message here"
                                value={props.modalData.message}
                                disabled
                            />
                        </Form.Group>
                    </Form>
                </div>
            </Modal.Body>
        </Modal>
    )
}